import { render, staticRenderFns } from "./DuanDaokaDataLight.vue?vue&type=template&id=0cfa6232&scoped=true"
import script from "./DuanDaokaDataLight.vue?vue&type=script&lang=js"
export * from "./DuanDaokaDataLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfa6232",
  null
  
)

export default component.exports